import { Link } from "gatsby"
import styled from "styled-components"

/** ------------------------------------------------------------------------
 * Center aligned div which holds the base content of any page
 */
export const CenteredLayout = styled.div<{
  size?: number
  mobileMax?: boolean
  mobilePadding?: number
}>`
  width: 100%;
  max-width: ${({ size }) => (size ? `${size}px` : "1200px")};
  margin: 0 auto;

  @media (max-width: 1200px) {
    padding-left: 40px;
    padding-right: 40px;
    width: calc(100% - 80px);
  }

  @media (max-width: 560px) {
    width: ${({ mobileMax, mobilePadding }) =>
      mobileMax ? `100%` : `calc(100% - ${(mobilePadding || 20) * 2}px)`};
    overflow: hidden;
    padding-left: ${({ mobileMax, mobilePadding }) =>
      mobileMax ? `0` : `${mobilePadding || 20}px`};
    padding-right: ${({ mobileMax, mobilePadding }) =>
      mobileMax ? `0` : `${mobilePadding || 20}px`};
  }
`
export const SPOnlyCenteredLayout = styled(CenteredLayout)`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`
export const DesktopOnlyCenteredLayout = styled(CenteredLayout)`
  display: none;
  @media screen and (min-width: 768px) {
    display: block;
  }
`

export const SPOnlyDiv = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`
export const DesktopOnlyDiv = styled.div`
  display: none;
  @media screen and (min-width: 768px) {
    display: block;
  }
`
/** ------------------------------------------------------------------------
 * Flex div with row direction and center alignemt as default
 */
export const Flex = styled.div<{
  isColumn?: boolean
  isWrap?: boolean
  isStart?: boolean
}>`
  display: flex;
  flex-direction: ${({ isColumn }) => (isColumn ? "column" : "row")};
  flex-wrap: ${({ isWrap }) => (isWrap ? "wrap" : "none")};
  align-items: center;
  justify-content: ${({ isStart }) => (isStart ? "flex-start" : "center")};
  text-decoration: none;
`

export const SPOnlyFlex = styled(Flex)`
  display: none;
  @media screen and (max-width: 767px) {
    display: flex;
  }
`
export const DesktopOnlyFlex = styled(Flex)`
  display: none;
  @media screen and (min-width: 768px) {
    display: flex;
  }
`

/** ------------------------------------------------------------------------
 * Header style
 */
export const BottomBorderedHeaderDiv = styled.div`
  background: white;
  border-bottom: 1px solid #d8d8d8;
`

/** ------------------------------------------------------------------------
 * Gatsby link, formatted in a way that it does not overwrite anythiny in the child components
 */
export const StyledLink = styled<typeof Link>(Link)`
  text-decoration: none;
  color: inherit;
`

/** ------------------------------------------------------------------------
 * White overlay for the top menu
 */
export const MenuOverlay = styled.div<{
  isActive: boolean
  isMobile?: boolean
}>`
  position: absolute;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.6);
  top: ${({ isMobile }) => (isMobile ? "57px" : "84px")};
  left: 0px;
  z-index: 10;
  opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  pointer-events: ${({ isActive }) => (isActive ? "all" : "none")};
  transition: 0.2s;
`

export const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(36, 36, 36, 0.8);
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
`
